import {getScriptSettings} from '../common/settings';

/**
 * Helper function for pushing an action onto the Tracker Data Layer.
 * @param {TrackerDataLayer~TrackersCallback} callback
 */
export function trackersPush(callback) {
  const {settings: {trackersDataLayerName = 'trackersJsDataLayer'} } = getScriptSettings();

  window[trackersDataLayerName] = window[trackersDataLayerName] || [];
  window[trackersDataLayerName].push(callback);
}
